export default __webpack_public_path__ + "static/Plate_2x2_Earth_Blue_RGB-92584a6ec722fee6b3bfb4d88b62eac5.svg";